import React, { useEffect, useState } from "react";
import { AddImageServ, EnhanceImageMultiple, OrderImagesServ, ProcessAllImageServ, RedoServ, RemoveImageServ, ResetServ, UndoServ } from "../../../Services/AIListingCreation";
import UndoImage from "../../Comp-enhance-AIlisting/undo-image";
import RedoImage from "../../Comp-enhance-AIlisting/redo-image";
import ResetImage from "../../Comp-enhance-AIlisting/reset-image";
import OrderListings from "../../Comp-enhance-AIlisting/order-listings";
import { ProcessMultiImageServ, SaveEnhancedImage } from "../../../Services/Enhance";
import AddImage from "../../Comp-enhance-AIlisting/add-image";
import { fetchHeaderData } from "../../store/headerSlice";
import { useAppDispatch } from "../../store/store";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { useTranslation } from "react-i18next";
import Recommendation from "../../Comp-enhance-AIlisting/recommendation/recommendation";
import BeforeAfterSlider from "../../Comp-enhance-AIlisting/before-after-slider";
import ApplyAllImages from "../../Comp-enhance-AIlisting/enhancement/apply-all-images";
import AdvancedGeneration from "../../Comp-enhance-AIlisting/generation/advanced-generation";
import AllEnhancement from "../../Comp-enhance-AIlisting/enhancement/all-enhancement";

const GenerateImages: React.FunctionComponent<{ onChangeTaps: any, onChangeMessagehandler: any, onShowMessageUpgrade: any, isOversized: boolean, listingValue: any }> = (props) => {

    const [activeTab, setActiveTab] = useState<string>("Recommendation");
    const [listingValue, setListingValue] = useState<any>(sessionStorage.getItem("listing") ? JSON.parse(sessionStorage.getItem("listing") || "") : props.listingValue);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [imageSelected, setImageSelected] = useState<any[]>([]);
    const [isChangeData, setIsChangeData] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState<boolean>(props.isOversized);
    const [processingImages, setProcessingImages] = useState<Array<string | number>>([]);
    const [isApplyingMap, setIsApplyingMap] = useState<Record<string, boolean>>({});
    const [processingIds, setProcessingIds] = useState<Array<string | number>>([]);
    const [isApplying, setIsApplying] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [processedImages, setProcessedImages] = useState<any[]>([]);
    const [clearSelection, setClearSelection] = useState<boolean>(false);

    useEffect(() => {
        if (listingValue.images && listingValue.images[currentImageIndex]) {
            if (imageSelected.length === 0) {
                setImageSelected([listingValue.images[currentImageIndex]]);
            }
        }
    }, [currentImageIndex, listingValue, imageSelected]);

    useEffect(() => {
        const listing = sessionStorage.getItem("listing");
        if (listing) {
            const parsedListing = JSON.parse(listing);
            if (JSON.stringify(parsedListing) !== JSON.stringify(listingValue)) {
                setListingValue(parsedListing);
            }
        }

    }, [isChangeData, props.listingValue]);

    useEffect(() => {
        setProcessingImages(processingImages);
    }, [processingImages]);

    const handleSelectedImages = (images: any[], index: any) => {
        setCurrentImageIndex(index);
        if (images.length > 0) {
            // filter: keep only images that still match sessionStorage state
            const freshData = sessionStorage.getItem("listing");
            let validImages = images;
            if (freshData) {
                const parsedData = JSON.parse(freshData);
                validImages = images.filter((img: any) => {
                    const fresh = parsedData.images.find((f: any) => f.id === img.id);
                    return fresh && fresh.src === img.src; // only keep if not updated yet
                });
            }

            setImageSelected(validImages);
        } else {
            setImageSelected([listingValue.images[index]]);
        }
    };

    const EnhancedImageHandler = async (images: any[], url: string, data: any) => {
        setIsApplying(true);
        setProcessedImages([]);
        // Clear all selected images at the start to allow user to select a new group for other enhancements
        setImageSelected([]);
        setClearSelection(true);
        // Reset clearSelection flag after a brief delay to allow the child component to react
        setTimeout(() => setClearSelection(false), 100);
        // Track which images are currently being processed for precise spinner control
        const keys = images.map((img) => `${img.id}:${url}`);
        setProcessingImages((prev) => [...prev, ...keys]);
        setProcessingIds((prev) => [...prev, ...images.map((img) => img.id)]);
        setIsApplyingMap((prev) => {
            const updated = { ...prev };
            images.forEach((img) => {
                updated[img.id] = true;
            });
            return updated;
        });
        for (let i = 0; i < images.length; i++) {
            const image = images[i];
            try {
                const obj = {
                    processid: sessionStorage.getItem("processid"),
                    images: [image], // 👈 one image at a time
                    url: url,
                    data: data,
                };
                const resp = await ProcessMultiImageServ(obj);
                // update sessionStorage with latest state
                sessionStorage.setItem("listing", JSON.stringify(resp));
                setListingValue(resp);
                setIsChangeData(!isChangeData);
                // Image selection already cleared at start of enhancement process
                props.onChangeMessagehandler("Image Enhanced Successfully !", true, "success");
                dispatch(fetchHeaderData());
            } catch (error: any) {
                if (error.response?.status === 401) {
                    props.onShowMessageUpgrade(error.response.data.message);
                } else {

                    props.onChangeMessagehandler("Failed to enhance image. Please try again.", true, "error");
                }
            } finally {
                setIsApplying(false);
                setProcessingIds((prev) => prev.filter((id) => id !== image.id));
                setProcessingImages((prev) => prev.filter((id: any) => id !== `${image.id}:${url}`));
                setIsApplyingMap((prev) => {
                    const updated = { ...prev };
                    updated[image.id] = false;
                    return updated;
                });
                // Image selection already cleared at start of enhancement process
            }
        }
    };

    const GeneratedImageHandler = async (images: any[], url: string, data: any) => {

        setIsApplying(true);
        setProcessedImages([]);
        setImageSelected([]);
        setClearSelection(true);

        // Reset clearSelection flag after a brief delay to allow the child component to react
        setTimeout(() => setClearSelection(false), 100);

        const keys = images.map((img) => `${img.id}:${url}`);
        setProcessingImages((prev) => [...prev, ...keys]);
        setProcessingIds((prev) => [...prev, ...images.map((img) => img.id)]);
        setIsApplyingMap((prev) => {
            const updated = { ...prev };
            images.forEach((img) => {
                updated[img.id] = true;
            });
            return updated;
        });
        if (Array.isArray(images)) {
            for (let i = 0; i < images.length; i++) {
                const img = images[i];
                try {
                    const obj = {
                        processid: sessionStorage.getItem('processid'),
                        images: [img],
                        url: url,
                        data: data
                    };
                    const resp = await ProcessMultiImageServ(obj);
                    sessionStorage.setItem("listing", JSON.stringify(resp));
                    setListingValue(resp);
                    setIsChangeData((prev) => !prev);
                    props.onChangeMessagehandler("Image Generated Successfully !", true, "success");
                    setTimeout(() => {
                        dispatch(fetchHeaderData());
                    }, 2000)
                } catch (error: any) {
                    if (error?.response?.status === 401) {
                        props.onShowMessageUpgrade(error.response.data.message);
                    } else {

                        props.onChangeMessagehandler("Failed to generate image. Please try again.", true, "error");
                    }
                } finally {
                    setIsApplying(false);
                    setProcessingIds((prev) => prev.filter((id) => id !== img.id));
                    setProcessingImages((prev) => prev.filter((id: any) => id !== `${img.id}:${url}`));
                    setIsApplyingMap((prev) => {
                        const updated = { ...prev };
                        updated[img.id] = false;
                        return updated;
                    });
                }
            }
        }
    };

    const ApplyAllImagesHandler = async (url: string, data: any) => {
        setIsApplying(true);
        setImageSelected([]);
        setClearSelection(true);
        // Reset clearSelection flag after a brief delay to allow the child component to react
        setTimeout(() => setClearSelection(false), 100);
        const allImages: any[] = (listingValue && Array.isArray(listingValue.images)) ? listingValue.images : [];
        const images = allImages.filter((img) => {
            return !img.doneEnhancments?.includes("Image Super Resolution");
        });
        const keys = images.map((img) => `${img.id}:${url}`);
        setProcessingImages((prev) => [...prev, ...keys]);
        setProcessingIds((prev) => [...prev, ...images.map((img) => img.id)]);
        setIsApplyingMap((prev) => {
            const updated = { ...prev };
            images.forEach((img) => {
                updated[img.id] = true;
            });
            return updated;
        });
        if (url === "Add Watermark") {
            try {
                for (let i = 0; i < images.length; i++) {
                    const img = images[i];
                    try {
                        const obj = {
                            processid: sessionStorage.getItem('processid'),
                            images: [img],
                            url: url,
                            data: data
                        };
                        const resp = await ProcessMultiImageServ(obj);
                        sessionStorage.setItem("listing", JSON.stringify(resp));
                        setListingValue(resp);
                        setIsChangeData((prev) => !prev);
                        props.onChangeMessagehandler("Image Enhanced Successfully !", true, "success");
                        setTimeout(() => {
                            dispatch(fetchHeaderData());
                        }, 2000);
                    } catch (error: any) {
                        if (error?.response?.status === 401) {
                            props.onShowMessageUpgrade(error.response.data.message);
                        } else {
                            props.onChangeMessagehandler( "Failed to enhance image. Please try again.", true, "error");
                        }
                    } finally {
                        setProcessingIds((prev) =>
                            prev.filter((id) => id !== img.id)
                        );
                        setProcessingImages((prev) =>
                            prev.filter((id: any) => id !== `${img.id}:${url}`)
                        );
                        setIsApplyingMap((prev) => {
                            const updated = { ...prev };
                            updated[img.id] = false;
                            return updated;
                        });
                    }
                }
            } finally {
                setIsApplying(false);
            }
        }
        else {
            try {
                const obj = {
                    processid: sessionStorage.getItem('processid'),
                    url: url,
                    data: data
                };
                const resp = await ProcessAllImageServ(obj);
                sessionStorage.setItem("listing", JSON.stringify(resp));
                setListingValue(resp);
                setIsChangeData((prev) => !prev);
                props.onChangeMessagehandler("Image Enhanced Successfully !", true, "success");
                setTimeout(() => {
                    dispatch(fetchHeaderData());
                }, 2000)
            } catch (error: any) {
                if (error?.response?.status === 401) {
                    props.onShowMessageUpgrade(error.response.data.message);
                } else {
                    props.onChangeMessagehandler(error.response.data.message ? error.response.data.message : "Failed to enhance image. Please try again.", true, "error");
                }
            } finally {
                setIsApplying(false);
                setProcessingIds([]);
                setProcessingImages([]);
                setIsApplyingMap({})
            }
        }

    };

    const AddImagesHandler = (obj: any, value: boolean) => {
        setImageSelected([]);
        setIsOpen(value)
        const id = sessionStorage.getItem("processid") || "";
        return new Promise((resolve, reject) => {
            AddImageServ(id, obj).then((resp) => {
                const existingData = sessionStorage.getItem("listing");
                let parsedData = [];
                if (existingData) {
                    parsedData = JSON.parse(existingData);
                }
                parsedData = resp;
                sessionStorage.setItem("listing", JSON.stringify(parsedData));
                setIsChangeData(!isChangeData)
                props.onChangeMessagehandler("Images Uploaded Successfully !", true, "success");
                resolve(resp);
            }).catch((error) => {
                props.onChangeMessagehandler("Failed to Upload images. Please try again.", true, "error");
                reject(error);
            })
        });
    };

    const UndoImageHandler = (value: any) => {
        setIsApplying(true);
        setImageSelected([]);
        setClearSelection(true);

        // Reset clearSelection flag after a brief delay to allow the child component to react
        setTimeout(() => setClearSelection(false), 100);
        return new Promise((resolve, reject) => {
            UndoServ({ processid: sessionStorage.getItem('processid'), imageid: value }).then((resp) => {
                const existingData = sessionStorage.getItem("listing");
                let parsedData = [];
                if (existingData) {
                    parsedData = JSON.parse(existingData);
                }
                parsedData = resp;
                sessionStorage.setItem("listing", JSON.stringify(parsedData));
                resolve(resp);
                setIsChangeData(!isChangeData)
                setIsApplying(false);

            }).catch((error) => {
                props.onChangeMessagehandler(error.response.data.error || error.response.data.message, true, "error");
                setIsApplying(false);
                reject(error);

            })
        });
    };

    const ResetImageHandler = (value: any) => {
        setIsApplying(true);
        setImageSelected([]);
        setClearSelection(true);

        // Reset clearSelection flag after a brief delay to allow the child component to react
        setTimeout(() => setClearSelection(false), 100);
        return new Promise((resolve, reject) => {
            ResetServ({ processid: sessionStorage.getItem('processid'), imageid: value }).then((resp) => {
                const existingData = sessionStorage.getItem("listing");
                let parsedData = [];
                if (existingData) {
                    parsedData = JSON.parse(existingData);
                }
                parsedData = resp;
                sessionStorage.setItem("listing", JSON.stringify(parsedData));
                resolve(resp);
                setIsChangeData(!isChangeData)

            }).catch((error) => {
                props.onChangeMessagehandler(error.response.data.error || error.response.data.message, true, "error");
                reject(error);

            })
        });
    };

    const RedoImageHandler = (value: any) => {
        setIsApplying(true);
        setImageSelected([]);
        setClearSelection(true);

        // Reset clearSelection flag after a brief delay to allow the child component to react
        setTimeout(() => setClearSelection(false), 100);
        return new Promise((resolve, reject) => {
            RedoServ({ processid: sessionStorage.getItem('processid'), imageid: value }).then((resp) => {
                const existingData = sessionStorage.getItem("listing");
                let parsedData = [];
                if (existingData) {
                    parsedData = JSON.parse(existingData);
                }
                parsedData = resp;
                sessionStorage.setItem("listing", JSON.stringify(parsedData));
                resolve(resp);
                setIsChangeData(!isChangeData)

            }).catch((error) => {
                props.onChangeMessagehandler(error.response.data.error || error.response.data.message, true, "error");
                reject(error);

            })
        });
    };

    const handleDelete = (id: any) => {

        return new Promise((resolve, reject) => {
            const obj = {
                processid: sessionStorage.getItem('processid'),
                imageid: id
            }
            RemoveImageServ(obj).then((resp) => {
                const existingData = sessionStorage.getItem("listing");
                let parsedData = [];
                if (existingData) {
                    parsedData = JSON.parse(existingData);
                }
                parsedData = resp;
                sessionStorage.setItem("listing", JSON.stringify(parsedData));
                setIsChangeData(!isChangeData)
                props.onChangeMessagehandler("Image Deleted Successfully!", true, "success");
                setCurrentImageIndex(0);
                resolve(resp);
            }).catch((error) => {
                props.onChangeMessagehandler("Failed to delete image.", true, "error");
                reject(error);
            })
        });
    };

    const SaveOrderHandler = (images: any) => {
        return new Promise((resolve, reject) => {
            const obj = {
                processid: sessionStorage.getItem('processid'),
                images: images
            };
            OrderImagesServ(obj).then((resp) => {
                const existingData = sessionStorage.getItem("listing");
                let parsedData = [];
                if (existingData) {
                    parsedData = JSON.parse(existingData);
                }
                parsedData = resp;
                sessionStorage.setItem("listing", JSON.stringify(parsedData));
                setIsChangeData(!isChangeData)
                props.onChangeMessagehandler("The order of images has been successfully updated !", true, "success");
                resolve(resp);
            }).catch((error) => {
                props.onChangeMessagehandler(error.response.data.message, true, "error");
                reject(error);
            })
        });
    };

    const ChangeMessagehandler = (msg: string, isError: boolean, color: string) => {
        setIsChangeData(!isChangeData)
        props.onChangeMessagehandler(msg, isError, color);
    };

    const AnalysisCompleteHandler = (data: any, isError: boolean, msg: string) => {
        try {
            if (!isError) {
                const listingStr = sessionStorage.getItem("listing");

                if (!listingStr) {
                    console.log("No listing data found in session.");
                    return;
                }

                const listing = JSON.parse(listingStr);

                if (!listing.images || !Array.isArray(listing.images)) {
                    console.log("Invalid listing data format.");
                    return;
                }

                const updatedImages = listing.images.map((img: any) => {
                    if (img.id === data?.imageId || img.id === data?.image?.id) {
                        return {
                            ...data.image,
                            toAnalyze: true,
                            originalImage: img.originalImage,
                        };
                    }
                    return img;
                });

                const updatedListing = { ...listing, images: updatedImages };
                sessionStorage.setItem("listing", JSON.stringify(updatedListing));

                props.onChangeMessagehandler("Image analysis completed successfully!", true, "success");
            } else {
                props.onChangeMessagehandler(msg, true, "error");
            }
        } catch (error) {
            console.error("Error in AnalysisCompleteHandler:", error);
            props.onChangeMessagehandler("An unexpected error occurred while updating the analysis data.", true, "error");
        }
    };


    const HandleClickNext = () => {
        props.onChangeTaps("TitleAndDescription");
    };


    return (
        <>
            <div className="row ">
                <div className="col-md-6 d-flex mb-3">
                    <a className="buuton-next border-trans  marg-right-16 back-EEF2FF border-9" href="/properties">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 14L13 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 7" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </a>
                    <div className="header-title">
                        <h1 className="title-24 title-20-mb mb-3"> {t("startUploading.title")}</h1>
                        <p className="para-16 color-39393B">  {t("listingCreation.subTitle")}</p>
                    </div>
                </div>
                <div className="col-md-6 d-flex justify-content-end align-items-center mb-3">
                    <button className={`button-reset back-746AFF color-FFFFFF width-auto border-746AFF padd-15-30`} onClick={HandleClickNext}>

                        {t("listingCreation.goToTitle")} <svg width="25" height="24" className="marg-left-10" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_504_685)">
                                <path d="M5.5 12H19.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.5 18L19.5 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.5 6L19.5 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_504_685">
                                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </div>
            </div>

            <div className="row">
                <div className="col-md-4 order-22  scroll-container max-height-65">
                    {/* Enhancement Tabs Container */}
                    <div className="enhancement-tabs-container mb-4 ">
                        <div className="d-flex justify-content-between gap-20 align-items-center mb-4">
                            <h3 className="title-20 color-black text-nowrap">
                                {t("enhancementList.title")}</h3>
                        </div>

                        <div className="tabs mb-4 width-tabs">
                            <button
                                className={`tab para-14 width-100-100 color-black bold-500 ${activeTab === "Recommendation" ? "active" : ""}`}
                                onClick={() => setActiveTab("Recommendation")} >
                                {t("enhancementList.recommendation")}
                            </button>
                            <button
                                className={`tab para-14 color-black width-100-100 bold-500 ${activeTab === "AllEnhancement" ? "active" : ""}`}
                                onClick={() => setActiveTab("AllEnhancement")}
                            >
                                {t("enhancementList.allEnhancement")}
                            </button>
                        </div>

                        {activeTab == "Recommendation" ? <ul className="p-0 m-0 list-style-none mb-0">
                            <Recommendation recommendationsValue={imageSelected} processId={sessionStorage.getItem('processid') || ""} onAnalysisComplete={AnalysisCompleteHandler} onEnhancedImage={EnhancedImageHandler} processingIds={processingImages} isApplyingMap={isApplyingMap} currentImageIndex={currentImageIndex} listing={listingValue} />
                        </ul> :
                            <ul className="p-0 m-0 list-style-none mb-0">
                                <AllEnhancement imageValue={imageSelected} onEnhancedImage={EnhancedImageHandler}   processingIds={processingImages} isApplyingMap={isApplyingMap} currentImageIndex={currentImageIndex} listing={listingValue} />
                            </ul>
                        }
                    </div>

                    {/* Generate Container */}
                            <AdvancedGeneration imageValue={imageSelected} onEnhancedImage={GeneratedImageHandler} onChangeMessagehandler={ChangeMessagehandler} processingIds={processingImages} isApplyingMap={isApplyingMap} currentImageIndex={currentImageIndex} listing={listingValue} />
                </div>
                <div className="col-md-8 order-11">
                    <div className="card border-20 mb-4" >
                        <div className="card-body  padd-24">
                            <div className="row d-flex justify-content-between align-items-center">
                                <div className="col-1 mb-4">

                                    <UndoImage imageValue={listingValue.images && listingValue.images[currentImageIndex] ? listingValue.images[currentImageIndex] : null} onUndoImage={UndoImageHandler} />

                                    <RedoImage imageValue={listingValue.images && listingValue.images[currentImageIndex] ? listingValue.images[currentImageIndex] : null} onRedoImage={RedoImageHandler} />

                                </div>

                                <div className="col-2 mb-4 d-flex justify-content-end">

                                    <ResetImage imageValue={listingValue.images && listingValue.images[currentImageIndex] ? listingValue.images[currentImageIndex] : null} onResetImage={ResetImageHandler} />

                                    <AddImage onAddImages={AddImagesHandler} />

                                </div>
                            </div>

                            <BeforeAfterSlider images={listingValue.images} onDelete={handleDelete} onSelectedImages={handleSelectedImages} applaying={isApplying} processedImages={processedImages} setapplying={setIsApplying} processingIds={processingIds} clearSelection={clearSelection} />

                            <div className="row d-flex justify-content-between align-items-center  mb-4  mt-4">
                                <div className="col-1">
                                    <h3 className="title-20 title-18-mb color-black ">
                                        {t("enhancementList.applyToAllImages")}
                                    </h3>
                                </div>
                                <div className="col-2 d-flex justify-content-end">
                                    <OrderListings listingValue={listingValue.images} onSaveOrder={SaveOrderHandler} />
                                </div>
                            </div>

                            <div className="row d-flex justify-content-center ">
                                <ApplyAllImages onApplyAllImages={ApplyAllImagesHandler} onChangeMessagehandler={ChangeMessagehandler} processingIds={processingImages} />
                            </div>

                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-end order-33">
                    <button className={`button-reset back-746AFF color-FFFFFF width-auto border-746AFF padd-15-30`} onClick={HandleClickNext}>
                        {t("listingCreation.goToTitle")} <svg width="25" height="24" className="marg-left-10" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_504_685)">
                                <path d="M5.5 12H19.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.5 18L19.5 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.5 6L19.5 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_504_685">
                                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </div>
            </div>

            <Dialog
                open={isOpen}
                onClose={() => setIsOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogContent>
                    <p className="title-18 bold-500 line-height-30 color-000000 marg-bottom-0">
                        {t("startUploading.sizeLimit")}
                    </p>
                </DialogContent>
                <DialogActions>
                    <button type="button" className="button-dash border-4F52C1 color-4F52C1 back-trans padd-15" onClick={() => setIsOpen(false)}>
                        {t("startUploading.gotIt")}
                    </button>
                </DialogActions>
            </Dialog>

        </>
    )
}
export default GenerateImages;